import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CallDetailPage } from './call-detail';

@NgModule({
  declarations: [
    CallDetailPage,
  ],
  imports: [
    IonicPageModule.forChild(CallDetailPage),
  ],
})
export class CallDetailPageModule {}



// WEBPACK FOOTER //
// ./src/pages/call-detail/call-detail.module.ts